import { makeStyles } from 'tss-react/mui';

const name = 'ChainPageSkeleton';

export const useChainPageSkeletonStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',

    gap: theme.spacing(7.5),

    [theme.breakpoints.down('lg')]: {
      gap: theme.spacing(4),
    },
  },
}));
